import { createFileRoute } from '@tanstack/react-router'
import { UsersList } from '@/features/UserMangment/userlist/users-list'

export const Route = createFileRoute(
  '/_authenticated/dashboard/usermanagment',
)({
  component: UsersList,
})
